import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router';

import { localizedPath } from '../i18n/config';
import { useLocale } from '../i18n/useLocale';
import { LanguageMenu } from './LanguageMenu';
import { Logo } from './Logo';
import { SignInLabel } from './SignInLabel';

export function SiteHeader() {
  const { t } = useTranslation();
  const locale = useLocale();
  const home = localizedPath(locale, '/');

  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <Link to={home} className="logo-link" aria-label={t('nav.home')}>
          <Logo />
        </Link>
        <nav aria-label={t('nav.main')} className="site-nav">
          <NavLink to={localizedPath(locale, '/models')}>{t('nav.models')}</NavLink>
          <a href={`${home}#prices`}>{t('nav.prices')}</a>
          <NavLink to={localizedPath(locale, '/docs')}>{t('nav.docs')}</NavLink>
          <a href={`${home}#referrals`}>{t('nav.referrals')}</a>
          <a href={`${home}#faq`}>{t('nav.faq')}</a>
        </nav>
        <div className="site-header-actions">
          <LanguageMenu />
          <Link to="/app" className="button button-primary button-small">
            <SignInLabel />
          </Link>
        </div>
      </div>
    </header>
  );
}
